{
	"placeholder": "Поиск по материалам, конспектам, карточкам, тестам…",
	"empty": {
		"initial": "Введи запрос или выбери действие",
		"noResults": "Ничего не нашли",
		"hint": "Попробуй другие слова или выбери действие ниже"
	},
	"groups": {
		"recents": "Недавние",
		"materials": "Материалы",
		"notes": "Конспекты",
		"flashcards": "Карточки",
		"quizzes": "Тесты",
		"chats": "Чаты",
		"actions": "Действия",
		"topics": "Темы курса"
	},
	"actions": {
		"ask": "Спросить репетитора",
		"askWith": "Спросить репетитора: «{query}»",
		"uploadMaterial": "Загрузить материал",
		"startRecording": "Начать запись лекции",
		"newNote": "Создать конспект",
		"openSettings": "Настройки",
		"toggleTheme": "Сменить тему",
		"openSearch": "Открыть полный поиск",
		"webSearch": "Поискать в вебе"
	},
	"preview": {
		"hint": "Наведи на результат — здесь появится превью"
	},
	"hints": {
		"navigate": "навигация",
		"select": "открыть",
		"close": "закрыть",
		"clearRecents": "Очистить недавние запросы"
	},
	"loading": "Ищем…",
	"error": {
		"title": "Не удалось выполнить поиск",
		"retry": "Повторить"
	}
}
